import { render, staticRenderFns } from "./ShiftDialogTable.vue?vue&type=template&id=1366e8c9"
import script from "./ShiftDialogTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShiftDialogTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports